import BSXCore from "@backstagex/core";
import { loadVendorJs } from "./helper.js";

loadVendorJs();

// styles
import '../scss/custom.scss'; // 如果需要客製化樣式，請在 custom.scss 中撰寫樣式

// 客製化 field
import fieldRelationCheckBox from './vueFormFieldComponents/fieldRelationCheckBox.vue';
BSXCore.registerFormField({
    fieldXRelationCheckBoxField: fieldRelationCheckBox,
});
import fieldQuillEditor from './vueFormFieldComponents/fieldQuillEditor/index.vue';
BSXCore.registerFormField({
    fieldXQuillEditor: fieldQuillEditor,
});

import fieldImage from './vueFormFieldComponents/fieldImage.vue';
BSXCore.registerFormField({
    fieldXImageField: fieldImage,
});

import fieldButtonCancelCourseBooking from './vueFormFieldComponents/fieldButtonCancelCourseBooking.vue';
BSXCore.registerFormField({
    fieldXButtonCancelCourseBookingField: fieldButtonCancelCourseBooking,
});

import staffCenterFeature from './vueFormSchema/StaffCenterFeature.js';
BSXCore.registerModule({
    menuItemKey: 'staff-center:feature',
    schema: staffCenterFeature,
});

import staffCenterAccount from './vueFormSchema/StaffCenterAccount.js';
BSXCore.registerModule({
    menuItemKey: 'staff-center:account',
    schema: staffCenterAccount,
});

import aboutUs from './vueFormSchema/AboutUs.js';
BSXCore.registerModule({
    menuItemKey: 'about-us:about-us',
    schema: aboutUs,
});

import aboutUsCategory from './vueFormSchema/AboutUsCategory.js';
BSXCore.registerModule({
    menuItemKey: 'about-us:about-us-categories',
    schema: aboutUsCategory,
});

import user from './vueFormSchema/User.js';
BSXCore.registerModule({
    menuItemKey: 'user:user',
    schema: user,
});

import news from './vueFormSchema/news.js';
BSXCore.registerModule({
    menuItemKey: 'news:news',
    schema: news,
});

import ApiErrorMessage from './vueFormSchema/ApiErrorMessage.js';
BSXCore.registerModule({
    menuItemKey: 'backend-tool:api-error-message',
    schema: ApiErrorMessage,
});

import bannerSchema from './vueFormSchema/Banner.js';
BSXCore.registerModule({
    menuItemKey: 'banner:banner',
    schema: bannerSchema,
});

import doctor from './vueFormSchema/HospitalDoctor.js';
BSXCore.registerModule({
    menuItemKey: 'hospital:doctor',
    schema: doctor,
});

import branchScheduleDisable from './vueFormSchema/HospitalBranchScheduleDisable.js';
BSXCore.registerModule({
    menuItemKey: 'hospital:branch-schedule-disable',
    schema: branchScheduleDisable,
});

import hospitalDistrict from './vueFormSchema/HospitalDistrict.js';
BSXCore.registerModule({
    menuItemKey: 'hospital:districts',
    schema: hospitalDistrict,
});

import hospitalBranch from './vueFormSchema/HospitalBranch.js';
BSXCore.registerModule({
    menuItemKey: 'hospital:branches',
    schema: hospitalBranch,
});

import hospitalClinic from './vueFormSchema/HospitalClinic.js';
BSXCore.registerModule({
    menuItemKey: 'hospital:clinics',
    schema: hospitalClinic,
});

import hospitalDepartment from './vueFormSchema/HospitalDepartment.js';
BSXCore.registerModule({
    menuItemKey: 'hospital:departments',
    schema: hospitalDepartment,
});

import hospitalDepartmentKeywords from './vueFormSchema/HospitalDepartmentKeywords.js';
BSXCore.registerModule({
    menuItemKey: 'hospital:departments-keywords',
    schema: hospitalDepartmentKeywords,
});

import hospitalDepartmentFirstDiagnosis from './vueFormSchema/HospitalDepartmentFirstDiagnosis.js';
BSXCore.registerModule({
    menuItemKey: 'hospital:departments-first-diagnosis',
    schema: hospitalDepartmentFirstDiagnosis,
});

import hospitalDepartmentSupportOnlineRegistration from './vueFormSchema/HospitalDepartmentSupportOnlineRegistration.js';
BSXCore.registerModule({
    menuItemKey: 'hospital:departments-support-online-registration',
    schema: hospitalDepartmentSupportOnlineRegistration,
});

import locationMap from './vueFormSchema/LocationMap.js';
BSXCore.registerModule({
    menuItemKey: 'about-us:location-map',
    schema: locationMap,
});

import PostpartumMeal from './vueFormSchema/PostpartumMeal.js';
BSXCore.registerModule({
    menuItemKey: 'about-us:postpartum-meal',
    schema: PostpartumMeal,
});

import Partner from './vueFormSchema/Partner.js';
BSXCore.registerModule({
    menuItemKey: 'about-us:partner',
    schema: Partner,
});

import ParentBabyBinding from './vueFormSchema/ParentBabyBinding.js';
BSXCore.registerModule({
    menuItemKey: 'parent-baby-binding:parent-baby-binding',
    schema: ParentBabyBinding,
});

import fieldXButtonRemoveParentBabyBinding from './vueFormFieldComponents/fieldXButtonRemoveParentBabyBinding.vue';
BSXCore.registerFormField({
    fieldXButtonRemoveParentBabyBinding: fieldXButtonRemoveParentBabyBinding,
});

import MaternityQaCategory from './vueFormSchema/MaternityQaCategory.js';
BSXCore.registerModule({
    menuItemKey: 'about-us:maternity-qa-category',
    schema: MaternityQaCategory,
});

import MaternityQaVideo from './vueFormSchema/MaternityQaVideo.js';
BSXCore.registerModule({
    menuItemKey: 'about-us:maternity-qa-video',
    schema: MaternityQaVideo,
});

import DiagnosisAndTreatment from './vueFormSchema/DiagnosisAndTreatment.js';
BSXCore.registerModule({
    menuItemKey: 'about-us:diagnosis-and-treatment',
    schema: DiagnosisAndTreatment,
});

import PostpartumCare from './vueFormSchema/PostpartumCare.js';
BSXCore.registerModule({
    menuItemKey: 'about-us:postpartum-care',
    schema: PostpartumCare,
});

import fieldOpinionResponse from './vueFormFieldComponents/fieldOpinionResponse.vue';
BSXCore.registerFormField({
    fieldXOpinionResponse: fieldOpinionResponse,
});

import Opinion from './vueFormSchema/Opinion.js';
BSXCore.registerModule({
    menuItemKey: 'opinion:opinion',
    schema: Opinion,
});

import FaqType from './vueFormSchema/FaqType.js';
BSXCore.registerModule({
    menuItemKey: 'faq:type',
    schema: FaqType,
});

import Faq from './vueFormSchema/Faq.js';
BSXCore.registerModule({
    menuItemKey: 'faq:faq',
    schema: Faq,
});

import CourseType from './vueFormSchema/CourseType.js';
BSXCore.registerModule({
    menuItemKey: 'course:type',
    schema: CourseType,
});

import CoursePlace from './vueFormSchema/CoursePlace.js';
BSXCore.registerModule({
    menuItemKey: 'course:place',
    schema: CoursePlace,
});

import Course from './vueFormSchema/Course.js';
BSXCore.registerModule({
    menuItemKey: 'course:course',
    schema: Course,
});

import CourseJoinGuest from './vueFormSchema/CourseJoinGuest.js';
BSXCore.registerModule({
    menuItemKey: 'course:guest',
    schema: CourseJoinGuest,
});

import CourseJoinMom from './vueFormSchema/CourseJoinMom.js';
BSXCore.registerModule({
    menuItemKey: 'course:mom',
    schema: CourseJoinMom,
});

import CourseJoinStaff from './vueFormSchema/CourseJoinStaff.js';
BSXCore.registerModule({
    menuItemKey: 'course:staff',
    schema: CourseJoinStaff,
});

import AppVersionControl from './vueFormSchema/AppVersionControl.js';
BSXCore.registerModule({
    menuItemKey: 'app-version-control:app-version-control',
    schema: AppVersionControl,
});

import botSchema from './vueFormSchema/Bot.js';
BSXCore.registerModule({
    menuItemKey: 'bot:bot',
    schema: botSchema,
});

import staff from './vueFormSchema/Staff.js'; BSXCore.registerModule({ menuItemKey: 'staff-center:staff', schema: staff, });

import StaffLink from './vueFormSchema/StaffLink.js';
BSXCore.registerModule({
    menuItemKey: 'staff-center:staff-links',
    schema: StaffLink,
});


BSXCore.registerRun();
